export const MQTT_ENDPOINT = `wss://mqtt.booknorder.co.nz:8884/mqtt`;
export const MQTT_USERNAME = "bno-stores";
export const MQTT_PASSWORD = "025ddd9f-efae-4364-8bf0-aa391b464ccf";

export const mqttTopics = {
  orderUpdates: (order_id: string) => `app/stores/order/${order_id}/update`,
  bookingUpdates: (booking_id: string) => `app/stores/booking/${booking_id}/update`,
};
